const ACTION_SCOPE = '[Product]';

export namespace ProductsAction {
  export class Set {
    static readonly type = `${ACTION_SCOPE} Set`;
    constructor(public items: any) {}
  }
}
